var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        width: _vm.fullscreen ? "100%" : 1080,
        placement: "right",
        closable: false,
        visible: _vm.visible,
        "body-style": { padding: 0, height: "100%" },
      },
      on: { close: _vm.onClose },
    },
    [
      _c(
        "a-spin",
        { attrs: { tip: "正在分析当前页面...", spinning: _vm.capturing } },
        [
          _c(
            "a-layout",
            { staticClass: "ai-assistant" },
            [
              _c(
                "a-layout-sider",
                {
                  staticStyle: {
                    "border-right": "1px solid #E5E8EB",
                    "background-color": "#EDF3FA",
                  },
                  attrs: { width: 250 },
                },
                [_c("ai-assistant-sider")],
                1
              ),
              _c(
                "a-layout-sider",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.agentsShow,
                      expression: "agentsShow",
                    },
                  ],
                  staticStyle: {
                    "border-right": "1px solid #E5E8EB",
                    "background-color": "#EDF3FA",
                  },
                  attrs: { width: 200 },
                },
                [_c("ai-assistant-agents")],
                1
              ),
              _c("ai-assistant-session", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.session,
                    expression: "session",
                  },
                ],
              }),
              _c("ai-assistant-agent", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.userAgent,
                    expression: "userAgent",
                  },
                ],
              }),
              _vm.close
                ? _c(
                    "div",
                    { staticClass: "ai-assistant__mask" },
                    [
                      _c("div", { staticClass: "ai-assistant__mask__tips" }, [
                        _vm._v("通信连接已断开"),
                      ]),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.setup },
                        },
                        [_vm._v("点击重连")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }